import { render, staticRenderFns } from "./NavPanel.vue?vue&type=template&id=10eca5b9&scoped=true"
import script from "./NavPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./NavPanel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NavPanel.vue?vue&type=style&index=0&id=10eca5b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eca5b9",
  null
  
)

export default component.exports